<ul>
	<li *ngFor="let productName of productNames">{{ productName }}</li>
</ul>

